// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './ColorToolIcon.scss';
import './ColorComboButton.scss';

const ColorToolIcon = ({
    className,
    color,
    backgroundColor,
    isActive,
    selectedType,
    selectedStatus,
    supportColorBar,
    supportBackgroundColor,
    secondaryColor,
}) => (
    <div
        className={classNames('ColorToolIcon', selectedType, selectedStatus, className, {
            active: isActive,
            'no-color': !color,
            'support-color-bar': supportColorBar,
            'support-background-color': supportBackgroundColor,
            'color-combination': !!secondaryColor,
        })}
    >
        <div
            className={classNames('color-icon color-target', {
                'background-color-target': !color,
            })}
            style={{ backgroundColor: color || backgroundColor }}
        >
            <div className="secondary-color-container">
                <div
                    className="secondary-color"
                    style={{ backgroundColor: secondaryColor, transform: `rotate(-52deg)` }}
                />
            </div>
        </div>

        {supportColorBar && (
            <div className="background-color-icon background-color-target" style={{ backgroundColor }} />
        )}
    </div>
);

ColorToolIcon.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    secondaryColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    backgroundColor: PropTypes.string,
    backgroundColorName: PropTypes.string,
    isActive: PropTypes.bool,
    supportColorBar: PropTypes.bool,
    supportBackgroundColor: PropTypes.bool,
    selectedType: PropTypes.string,
    selectedStatus: PropTypes.string,
};

export default ColorToolIcon;
